import { render } from "./TgModal.vue?vue&type=template&id=3b1c61d1"
import script from "./TgModal.vue?vue&type=script&lang=js"
export * from "./TgModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__